import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

export default function AccessPermissionCard({ permission }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const { t } = useTranslation();

  return (
    <Stack
      style={{ backgroundColor: '#d8efff' }}
      className="!p-[16px]"
    >
      <Stack direction={'row'}>
        <Stack flex={4}></Stack>
        <Stack flex={2} alignItems='center' justifyContent='center' ><Typography color={theme.palette.primary.text} className='!text-xs uppercase'>{t('View')}</Typography></Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs uppercase'>{t('Add')}</Typography></Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs uppercase'>{t('Modify')}</Typography></Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs uppercase'>{t('Archive')}</Typography></Stack>
      </Stack>
      {permission.map((p, pIndex) => <Stack key={pIndex} direction={'row'}>
        <Stack flex={4} justifyContent='center'>
          <Typography color={theme.palette.primary.text} className='!text-xs'>{t(`${p?.moduleName}`)}</Typography>
        </Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'>
          {p.viewAccess === '2' ? '-' :
            <IconButton
              style={{ backgroundColor: '#FFFFFF', height: '16px', width: '16px', borderRadius: '8px', alignItems: 'center', justifyContent: 'center' }}
              className="!my-[5px]"
            >
              {p?.viewAccess === '1' ? <CheckIcon style={{ transform: 'scale(1.143)', color: '#2EAE24', height: '12px' }} /> : <ClearIcon style={{ transform: 'scale(1.143)', color: '#E20D0D', height: '12px' }} />}
            </IconButton>}
        </Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'>
          {p.addAccess === '2' ? '-' : <IconButton
            style={{ backgroundColor: '#FFFFFF', height: '16px', width: '16px', borderRadius: '8px', alignItems: 'center', justifyContent: 'center' }}
            className="!my-[5px]"
          >
            {p?.addAccess === '1' ? <CheckIcon style={{ transform: 'scale(1.143)', color: '#2EAE24', height: '12px' }} /> : <ClearIcon style={{ transform: 'scale(1.143)', color: '#E20D0D', height: '12px' }} />}
          </IconButton>}
        </Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'>
          {p.editAccess === '2' ? '-' : <IconButton
            style={{ backgroundColor: '#FFFFFF', height: '16px', width: '16px', borderRadius: '8px', alignItems: 'center', justifyContent: 'center' }}
            className="!my-[5px]"
          >
            {p?.editAccess === '1' ? <CheckIcon style={{ transform: 'scale(1.143)', color: '#2EAE24', height: '12px' }} /> : <ClearIcon style={{ transform: 'scale(1.143)', color: '#E20D0D', height: '12px' }} />}
          </IconButton>}
        </Stack>
        <Stack flex={2} alignItems='center' justifyContent='center'>
          {p.archiveAccess === '2' ? '-' : <IconButton
            style={{ backgroundColor: '#FFFFFF', height: '16px', width: '16px', borderRadius: '8px', alignItems: 'center', justifyContent: 'center' }}
            className="!my-[5px]"
          >
            {p?.archiveAccess === '1' ? <CheckIcon style={{ transform: 'scale(1.143)', color: '#2EAE24', height: '12px' }} /> : <ClearIcon style={{ transform: 'scale(1.143)', color: '#E20D0D', height: '12px' }} />}
          </IconButton>}
        </Stack>
      </Stack>)}
    </Stack>
  );
}
